import './App.css';
import Header from '../src/Header';
import Pokemon from '../src/Pokemon';

function App() {
  return (
    <div className="App">
      <Header />
      <Pokemon />
    </div>
  );
}

export default App;
